import { BASE_API_URL } from "./api";

export const getImageDataUrl = async (url) => {
  const proxyUrl = `${BASE_API_URL}/image-proxy?url=${encodeURIComponent(url)}`;
  try {
    const response = await fetch(proxyUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error fetching image:", error);
    return null;
  }
};
